import { useEffect } from 'react';
import { useUser } from '@clerk/clerk-react';
import {
  IonCard,
  IonCardContent,
  IonText,
  IonButton,
} from '@ionic/react';
import { useI18n } from '../i18n/I18nProvider';
import { clearJoinHints, loadJoinHints } from '../lib/localStore';
import { emailMatchesHint, phoneMatchesHint } from '../lib/draftShare';
import useDraftMigration from '../hooks/useDraftMigration';

/** Runs pending draft migration after sign-in and shows join-hint banner when applicable. */
export function DraftMigrationRunner() {
  const { user, isLoaded } = useUser();
  const { migrateAllPending, needsMigration } = useDraftMigration();
  const { t } = useI18n();

  useEffect(() => {
    if (!isLoaded || !user?.id) return;
    if (!needsMigration) return;
    void migrateAllPending();
  }, [isLoaded, user?.id, needsMigration, migrateAllPending]);

  const hints = loadJoinHints();
  if (!isLoaded || !user || !hints) return null;

  const email = user.primaryEmailAddress?.emailAddress;
  const phone = user.primaryPhoneNumber?.phoneNumber;
  const matches =
    (hints.emailHint && email && emailMatchesHint(email, hints.emailHint)) ||
    (hints.phoneHint && phone && phoneMatchesHint(phone, hints.phoneHint));

  if (!matches && !hints.emailHint && !hints.phoneHint) return null;

  return (
    <IonCard color="primary">
      <IonCardContent>
        <IonText>
          <p>{matches ? t('join.welcomeMatch') : t('join.welcomeGeneric')}</p>
        </IonText>
        <IonButton fill="clear" onClick={() => clearJoinHints()}>
          {t('common.actions.close')}
        </IonButton>
      </IonCardContent>
    </IonCard>
  );
}

export default DraftMigrationRunner;
